import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=604384d4&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=604384d4&prod&scoped=true&lang=css&external"
import style1 from "./LoginForm.vue?vue&type=style&index=1&id=604384d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604384d4",
  null
  
)

export default component.exports